// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../css-loader/index.js??ref--8-1!../sass-loader/lib/loader.js??ref--8-2!./bulma.sass");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../vue-style-loader/lib/addStylesClient.js")("a2360fe6", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/bulma/bulma.sass
// module id = 601
// module chunks = 8